import type { Field, HighLightConditions } from '@lighthouse/core'
import fastEqual from 'fast-deep-equal'
import React, { memo, useDeferredValue, useMemo } from 'react'
import styled from 'styled-components'

import { useFieldBlockContext } from '../../contexts'
import { useAtomData } from '../../hooks'
import { selectRecordFromPool } from '../../utils'
import FieldValuePreviewer from '../FieldValuePreviewer'

interface TableCellProps {
    dsId: string
    recordId: string
    field: Field
    width?: number
    style?: React.CSSProperties
    isBold?: boolean
    styleConditions?: HighLightConditions
}

const SCxTableCell = styled.div<{ width?: number }>`
    position: relative;
    width: ${({ width }) => (width ? `${width}px` : '160px')};
    min-height: 36px;
    flex-shrink: 0;
    font-size: var(--font-size-normal);

    &.active {
        border: 1px solid var(--color-main);
    }
`

const TableValue: React.FC<TableCellProps> = ({ dsId, recordId, field, width, style, styleConditions, isBold }) => {
    const { recordPoolAtom } = useFieldBlockContext()
    // 使用 Map 的 O(1) 查找，useMemo 保持 selector 引用稳定
    const selector = useMemo(() => selectRecordFromPool(dsId, recordId), [dsId, recordId])
    const record = useDeferredValue(useAtomData(recordPoolAtom, selector))
    const data = record?.content?.[field.id]?.value
    return (
        <SCxTableCell width={width} style={style}>
            <FieldValuePreviewer
                field={field}
                data={data}
                previewHost="selectTable"
                isWrap={false}
                width={width}
                styleConditions={styleConditions}
                isBold={isBold}
            />
        </SCxTableCell>
    )
}

export default memo(TableValue, fastEqual)
